export const getClaimingExample = (summrayDetails) => {
  const billAmount = 5000;

  const afterBenefitPercentage = (billAmount * summrayDetails.BenefitPercentage) / 100;

  const afterExess = afterBenefitPercentage - summrayDetails.Excess;

  const wePay = afterExess;

  const youPay = billAmount - wePay;

  return { billAmount, afterBenefitPercentage, afterExess, wePay, youPay };
};
